/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:40:51
 */
const s = {
    ballDistance: 17.9,
    diameter: 8.7,
    numRows: 15,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [326.7355000014806, 328.74349041551324, 354.1528159712603, 356.20492670048486, 328.3269175653483, 327.94253009955696, 354.911502275232],
        1: [352.8032298452344, 352.3417785477232, 353.25125379731156, 327.4531258507797, 355.2593976329207, 329.47183440170147, 326.58047682238094, 327.8371861976096],
        2: [355.67045022609625, 355.57363482614545, 328.35037168481983, 329.2673795553011, 353.96506655527674, 328.37857953483984, 328.4470783444649, 327.20128882804255],
        3: [326.87423767310327, 329.5205037324329, 327.11265858815955, 328.43833218132727, 327.22272933753186, 328.58503732529255, 353.8914357312524, 327.1356233536547],
        4: [329.4231870770442, 356.1388795220044, 327.5696861053166, 355.95549386353014, 355.22413926735857, 328.0847979969868, 325.8824308404947, 328.2120610373283],
        5: [354.8515020443968, 352.3425048543322, 354.05985671010234, 329.4705746790828, 354.8953177101133, 329.52839517673056, 329.2868061753817, 327.10923347330606],
        6: [326.9492393332041, 329.55457542746393, 327.1697622877559, 326.64724306731694, 328.38752095737794, 327.0790041849969, 355.1192277359215, 328.21740999621386],
        7: [328.52783783160993, 352.8418476183373, 327.04805262489566, 352.49879782626215, 355.89166115246155, 329.6803688613893, 353.7986980217197, 356.13994097926803],
        8: [327.2605182643544, 352.6738567072184, 354.0761986754086, 327.3297561539271, 353.75750119228985, 327.14643019549806, 353.4015425302103, 327.9438058826185],
        9: [326.7491587599992, 356.255274048555, 355.19993432596345, 326.953160650002, 355.96865885993844, 325.716743473885, 326.8053842773045, 353.18462106619205],
        10: [352.4436580533198, 329.63889436840157, 326.7534586785572, 355.5256457250219, 353.7200270656612, 355.26176533149555, 353.8849437896849, 325.7085694822953],
        11: [326.82030900425065, 353.7149565969613, 329.5925970158393, 327.42435183428495, 352.91032715093036, 328.28826491705934, 327.2252028706118, 327.52345364751204],
        12: [353.709137748692, 326.7403201210318, 328.2401108244883, 353.41652836647285, 326.77451986949967, 326.8566095187766, 329.3211879366347, 352.3238901829369],
        13: [353.4611164773112, 326.6897304138423, 326.02865858241137, 328.03335564902414, 354.4649428052696, 327.26641068670466, 328.1533721843024, 328.06409448303555],
        14: [329.50812888207145, 326.77227893300267, 354.9055646388816, 329.17629524777556, 326.85005801792346, 352.96021056606753, 329.1852724577943, 355.96114752001995],
        15: [326.81235302524067, 352.90555550266663, 353.68296085511355, 326.7490531503851, 329.63421366945676],
        16: []
    }
};
export {s as default};
